import { Component, Input, Output, EventEmitter, ContentChildren, QueryList, AfterContentInit, Directive } from '@angular/core';
import { CommonModule } from '@angular/common';

export type BannerVariant = 'basic' | 'standard' | 'action' | 'detailed' | 'code';
export type BannerType = 'info' | 'success' | 'warning' | 'error' | 'testing';

// Directive to mark elements that should be projected into the banner action slot
@Directive({
  selector: '[bannerAction]',
  standalone: true
})
export class BannerActionDirective {
  constructor() {
  }
}

@Component({
  selector: 'app-status-banner',
  standalone: true,
  imports: [CommonModule, BannerActionDirective],
  templateUrl: './status-banner.component.html',
  styleUrls: ['./status-banner.component.scss']
})
export class StatusBannerComponent implements AfterContentInit {
  @Input() variant: BannerVariant = 'standard';
  @Input() type: BannerType = 'info';
  @Input() message: string = '';
  @Input() title: string = ''; // Used for detailed/code variant
  @Input() body: string = ''; // Used for detailed variant
  @Input() code: string = ''; // Used for code variant
  @Input() showIcon: boolean = true; // Used for code variant
  @Input() showSpinner: boolean = false;
  @Input() dismissible: boolean = false;
  @Input() linkUrl: string = ''; // URL for clickable link in detailed variant
  @Input() linkText: string = ''; // Text to display for the link
  @Output() linkClick = new EventEmitter<Event>(); // Event emitted when link is clicked
  @Output() dismissed = new EventEmitter<void>();

  @ContentChildren(BannerActionDirective) actions!: QueryList<BannerActionDirective>;

  hasActions = false;
  copySuccess = false;
  isHidden = false;

  dismiss(): void {
    this.isHidden = true;
    this.dismissed.emit();
  }

  ngAfterContentInit() {
    // Check if there's any projected content (actions)
    this.hasActions = this.actions && this.actions.length > 0;
  }

  copyCode(): void {
    if (!this.code) return;

    navigator.clipboard.writeText(this.code).then(
      () => {
        this.copySuccess = true;
        setTimeout(() => {
          this.copySuccess = false;
        }, 2000);
      },
      (err) => {
        console.error('Failed to copy code:', err);
      }
    );
  }
}
